// Define constant data here
export const defaultBroker = "Interactive Brokers";
// Define list of brokers
export const brokerList = ["Interactive Brokers", "Zerodha"];
// export const brokerList = ["UCAP", "Interactive Brokers", "Zerodha"];

export const requirements = [
  {
    label: "Minimum of 8 characters",
    status: false,
    validate: (password) => password.length >= 8,
  },
  {
    label: "1 uppercase letter",
    status: false,
    validate: (password) => /[A-Z]/.test(password),
  },
  {
    label: "1 lowercase letter",
    status: false,
    validate: (password) => /[a-z]/.test(password),
  },
  {
    label: "1 number",
    status: false,
    validate: (password) => /\d/.test(password),
  },
];

export const companyIcons = [
  "alipay",
  "android",
  "apple",
  "behance",
  "dribbble",
  "dropbox",
  "facebook",
  "github",
  "google",
  "instagram",
  "linkedin",
  "microsoft",
  "paypal",
  "pinterest",
  "reddit",
  "skype",
  "slack",
  "spotify",
  "twitch",
  "twitter",
  "whatsapp",
  "youtube",
];

export const crosairPlugin = {
  id: "corsair",
  defaults: {
    width: 1,
    color: "#FF4949",
    dash: [2, 4],
  },
  afterInit: (chart, args, opts) => {
    chart.corsair = {
      x: 0,
      y: 0,
    };
  },
  afterEvent: (chart, args) => {
    const { inChartArea } = args;
    const { type, x, y } = args.event;

    chart.corsair = { x, y, draw: inChartArea };
    chart.draw();
  },
  beforeDatasetsDraw: (chart, args, opts) => {
    const { ctx } = chart;
    const { top, bottom, left, right } = chart.chartArea;
    const { x, y, draw } = chart.corsair;
    if (!draw) return;

    ctx.save();

    ctx.beginPath();
    ctx.lineWidth = opts.width;
    ctx.strokeStyle = opts.color;
    ctx.setLineDash(opts.dash);
    ctx.moveTo(x, bottom);
    ctx.lineTo(x, top);
    ctx.moveTo(left, y);
    ctx.lineTo(right, y);
    ctx.stroke();

    ctx.restore();
  },
};

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const dateOptions = { day: "numeric", month: "short", year: "numeric" };

export const countries = [
  "United States",
  "United Kingdom",
  "Singapore",
  "India",
];

export const iconBucket =
  "https://elasticbeanstalk-us-east-1-860729282963.s3.amazonaws.com/";

// brokers

// Mock data for select inputs
// export const SelectBroker = ["Interactive Brokers", "Zerodha", "Other Brokers"];
export const SelectBroker = {
  "United States": ["Interactive Brokers", "Other Brokers"],
  India: ["Zerodha", "Other Brokers"],
};
// export const SelectBroker = ["Nuvama", "Zerodha", "Interactive Brokers"];

//social media accounts

export const LinkedIn = "https://www.linkedin.com/company/fort-investech/";
export const Instagram = "https://www.instagram.com/fortinvestechsystem/";
